/** @format */
/**
 * External dependencies
 */
import React from 'react';

/**
 * Internal dependencies
 */
import './style.scss';

const SettingsLayout = ( { children } ) => (
	<div className="wcpay-settings-layout">{ children }</div>
);

export default SettingsLayout;
